import styled from "styled-components";

export const GrayDiv = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.4rem;
  margin-top: 0.8rem;
`;
